import RouteTemplate from 'ember-route-template'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import IsSubco from 'teacher-ui-client/helpers/is-subco'
import { array, fn } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { not, eq } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { SummaryTablesTeachers } from 'teacher-ui-client/components/summary-tables/teachers'
import { SummaryTablesStudents } from 'teacher-ui-client/components/summary-tables/students'
import { on } from '@ember/modifier'
import type ReportingReSummaryTableRoute from 'teacher-ui-client/reporting/ui-scope/re/summary/table/route'
import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type Owner from '@ember/owner'

type SummaryTab = 'teachers' | 'students'

interface Signature {
  Args: {
    model: ModelFor<ReportingReSummaryTableRoute>
  }
}
export class ReStudentSummaryTablePage extends Component<Signature> {
  @service session!: SessionService

  @tracked currentTab: SummaryTab

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args)
    this.currentTab = this.session.currentTeacher.subcoFor(SubscriptionType.Reading) ? 'teachers' : 'students'
  }

  get isTeacherTab() {
    return this.currentTab === 'teachers'
  }

  setCurrentTab = (tab: SummaryTab) => {
    this.currentTab = tab
  }

  <template>
    <ReportingTeacherUiHeader @title={{t "reporting.summaryReportTitles.heading"}} />
    <ReportingDetailedControls
      @students={{@model.students}}
      @exportOptions={{array ExportType.CSV ExportType.print}}
      @isDataPresent={{true}}
      @showScopePicker={{not this.isTeacherTab}}
      @showDatePicker={{true}}
      @studentRouteName="reporting.ui-scope.re.student-summary"
    />
    <div>
      {{#if (IsSubco)}}
        <TabGroupComponent
          @theme={{themeKey "reading"}}
          @tabType={{TAB_TYPE_KEYS.shadow}}
          data-test-tab-group
          as |tabGroup|
        >
          <tabGroup.tab
            data-test-tab-all-teachers
            @isActive={{eq this.currentTab "teachers"}}
            {{on "click" (fn this.setCurrentTab "teachers")}}
          >
            {{t "reporting.summaryReportTitles.teachersTab"}}
          </tabGroup.tab>
          <tabGroup.tab
            data-test-tab-my-students
            @isActive={{eq this.currentTab "students"}}
            {{on "click" (fn this.setCurrentTab "students")}}
          >
            {{t "reporting.summaryReportTitles.studentsTab"}}
          </tabGroup.tab>
        </TabGroupComponent>
      {{/if}}

      <ContentTile class="relative print:border-none {{if (IsSubco) 'rounded-tl-none'}}">
        {{#if this.isTeacherTab}}
          <SummaryTablesTeachers
            @product={{@model.product}}
            @teachers={{@model.readingTeachers}}
            @teachersData={{@model.schoolSimpleSummary.teachers}}
            @schoolData={{@model.schoolSimpleSummary.school}}
          />
        {{else}}
          <SummaryTablesStudents
            @product={{@model.product}}
            @students={{@model.students}}
            @studentsData={{@model.studentsSimpleSummary.students}}
            @totalsData={{@model.studentsSimpleSummary.totals}}
          />
        {{/if}}
      </ContentTile>
    </div>
  </template>
}

export default RouteTemplate(ReStudentSummaryTablePage)
